var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./newstock.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-7d694646\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./newstock.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/newstock.vue
// module id = 24
// module chunks = 0